import { dapRedirectCommon } from '~/data/common/config/redirect'
export let dapRedirect = Object.freeze(deepMerge(dapRedirectCommon, {
}))
